<div class="comment-box p-3 d-flex bg-grey m-3">
    <div class="profile-icon profile-img-post">
        <span class="icon-char d-none"> D</span>
        <!-- <span class="img-prof" *ngIf="comment.user_image; else dummyimage"><img src="{{comment.user_image}}" alt="team"></span>
        <ng-template #dummyimage>
            <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
        </ng-template> -->
        <ng-container *ngIf="comment.user_image">
          <span class="img-prof" ><img src="{{profileUrl}}" alt="icon"  alt="team"></span>
        </ng-container>
        <ng-container *ngIf="!comment.user_image && comment.name">
          <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">{{comment.name.charAt(0).toUpperCase()}}</div>
        </ng-container>
        <ng-container *ngIf="!comment.user_image && !comment.name">
          <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
        </ng-container>
    </div>
    <div class="profile-name-type">
        <div *ngIf="comment.name; else dummyName">
            <h5>{{comment.name}}</h5>
        </div>
        <ng-template #dummyName>
            <div>
                <h5>Guest User</h5>
            </div>
        </ng-template>
        <div class="comment-info" *ngIf="comment.comment_description">{{comment.comment_description}}</div>
        <div class="reply-upboat-list">
            <ul>
                <li>
                    <a href="javascript:void(0)" (click)="addRemoveUpvote(comment.forum_id, 'forum')" class="upvote-list-item"><img src="assets/images/upvote-colored.svg" alt="upvote"> {{comment.totLikes}} Upvotes</a>
                </li>
                <li>
                    <a href="javascript:void(0)" class="reply-list-item" (click)="viewCommentBox()" SmoothScroll [scrollTo]="postReplyId" [duration]="500" [offset]="-100"><img src="assets/images/reply-solid.svg" alt="upvote"> reply</a>
                </li>
            </ul>
        </div>
    </div>
    <!-- <div class="dropdown post-options">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src="assets/images/icon.svg" alt="arrow-right" class="">
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/bookmark.svg" alt="bookmark">Save Post</a>
          <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/duplicate.svg" alt="duplicate"> Duplicate</a>
          <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/flag.svg" alt="flag"> Report</a>
      </div>
  </div> -->
</div>

<div *ngIf="!showReplies">
    <a class="btn btn-link" href="javascript:void(0)" (click)="viewReplies()">View Replies</a>
</div>
<div *ngIf="showReplies">
    <a class="btn btn-link" href="javascript:void(0)" (click)="viewReplies()">Hide Replies</a>
</div>

<ng-container *ngIf="showReplies">
    <div class="p-3">
        <comment-child-list [parentId]="comment.id" [forumId]="comment.forum_id"></comment-child-list>
    </div>
</ng-container>
<div id="{{postReplyId}}">
    <div *ngIf="showCommentBox && !showReplies" class="p-3">
        <app-create-comment [forumId]="comment.forum_id" [commentId]="comment.id" [parentCommentId]="comment.id" (commentSaved)="showRepliesSection()"></app-create-comment>
    </div>
</div>



















<!-- <div class="pahe-header mt-4">
    <h3>{{totalComments}} Answers</h3>
</div>
<div class="post-featured unanswered-posts mt-2 mb-4">
    <div class="post-unanswered-desc">
        <div class="post-detail-box bg-white box-shadow border-radius-10 border-all pb-3 mb-4" *ngFor="let comment of comments">
            <div class="comment-box p-3 d-flex bg-grey m-3">
                <div class="profile-icon profile-img-post">
                    <span class="icon-char d-none"> D</span>
                    <span class="img-prof" *ngIf="comment.user_image; else dummyimage"><img src="{{comment.user_image}}" alt="team"></span>
                    <ng-template #dummyimage>
                        <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
                    </ng-template>
                </div>
                <div class="profile-name-type">
                    <div *ngIf="comment.name; else dummyName">
                        <h5>{{comment.name}}</h5>
                    </div>
                    <ng-template #dummyName>
                        <div>
                            <h5>Guest User</h5>
                        </div>
                    </ng-template>
                    <div class="comment-info" *ngIf="comment.comment_description">{{comment.comment_description}}</div>
                    <div class="reply-upboat-list">
                        <ul>
                            <li>
                                <a href="#" class="upvote-list-item"><img src="assets/images/upvote-colored.svg" alt="upvote"> {{comment.totLikes}} Upvotes</a>
                            </li>
                            <li><a href="#" class="reply-list-item"><img src="assets/images/reply-solid.svg" alt="upvote"> reply</a></li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown post-options">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img src="assets/images/icon.svg" alt="arrow-right" class="">
                    </button>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/bookmark.svg" alt="bookmark">Save Post</a>
                        <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/duplicate.svg" alt="duplicate"> Duplicate</a>
                        <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/flag.svg" alt="flag"> Report</a>
                    </div>
                </div>
            </div>

            <div>
              <comment-child-list></comment-child-list>
            </div>
        </div>
    </div> -->
